<template>
	<div v-if="ticketGroups">
		<div v-if="ticketGroups.length > 0">
			<div class="label mt-2 mb-2">Entradas disponibles</div>
			<div class="tickets">
				<div class="group" v-for="group in ticketGroups" :key="group.id">
					<div
						class="ticket"
						v-for="ticket in group.ticketTypes"
						:key="ticket.id"
						:class="{ sold: !ticket.hasTicketsAvailable }"
					>
						<div class="flex-grow-1">
							<h3>{{ ticket.name }}</h3>
							<h5>{{ group.name }}</h5>
							<div class="price">$ {{ ticket.priceUnit }}</div>
							<div class="expire">Disponibles hasta {{ group.sellAt | moment("DD MMM YYYY HH:mm") }}</div>
						</div>
						<div>
							<select
								v-model="ticket.quantity"
								class="form-control"
								:disabled="ticket.ticketsAvailable == 0"
							>
								<option value="0">0</option>
								<option v-for="(n, index) in ticket.quantityAvailable" :key="index">
									{{ n }}
								</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="cart">
				<div class="cart-total">
					<span>Total</span>
					<span>$ {{ cartPriceTotal }}</span>
				</div>
			</div>

			<div
				class="btn btn-primary btn-block mt-3"
				@click="createOrder"
				:disabled="cartPriceTotal <= 0"
				:class="{ disabled: cartPriceTotal <= 0 }"
			>
				<span v-if="saving">Iniciando compra <span class="btn-loader" /> </span>
				<span v-else>Continuar</span>
			</div>
		</div>

		<div v-else>
			Aún no hay entradas disponibles a la venta
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "EventBuyTickets",
	props: {
		eventId: {
			type: String,
			required: true
		},
		eventCode: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			loading: false,
			saving: false,
			ticketGroups: null,
			orderId: null
		}
	},
	computed: {
		cartItems() {
			const cartItems = []
			this.ticketGroups.map((group) => {
				group.ticketTypes.map((ticket) => {
					if (ticket.quantity > 0) {
						ticket.groupName = group.name
						ticket.priceSubtotal = (ticket.priceUnit * ticket.quantity).toFixed(2)
						cartItems.push(ticket)
					}
				})
			})
			return cartItems
		},

		cartPriceTotal() {
			let total = 0
			this.ticketGroups.map((group) => {
				group.ticketTypes.map((ticket) => {
					if (ticket.quantity > 0) {
						total += ticket.priceUnit * ticket.quantity
					}
				})
			})
			return total.toFixed(2)
		}
	},
	async beforeMount() {
		await this.load()
	},
	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($eventId: ID!, $status: String) {
							eventTicketGroups(eventId: $eventId, status: $status) {
								data {
									id
									name
									minPerOrder
									maxPerOrder
									sellAt
									ticketTypes {
										id
										name
										priceUnit
										hasTicketsAvailable
									}
								}
							}
						}
					`,
					variables: {
						eventId: this.eventId,
						status: "ACTIVE"
					}
				})
				.then(({ data }) => {
					this.loading = false
					this.ticketGroups = data.eventTicketGroups.data.map((e) => {
						e.ticketTypes.map((t) => {
							t.quantity = 0
							t.quantityAvailable = Array(e.maxPerOrder - e.minPerOrder + 1)
								.fill()
								.map((_, idx) => e.minPerOrder + idx)
							return t
						})
						return e
					})

					return true
				})
		},

		createOrder() {
			if (this.cartItems.length == 0) {
				return
			}
			if (!this.saving) {
				this.saving = true

				let tickets = []
				this.cartItems.map((ticket) => {
					for (let t = 0; t < ticket.quantity; t++) {
						tickets.push({
							ticketTypeId: ticket.id
						})
					}
				})

				let data = {
					eventId: this.eventId,
					tickets,
					promotorCode: this.$store.getters.promotorCode || null
				}

				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: OrderInput!) {
								orderCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data
						}
					})
					.then(async ({ data }) => {
						this.$router.push(`/e/${this.eventCode}/purchase/${data.orderCreate.id}`)
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.saving = false
					})
			}
		}
	}
}
</script>

<style lang="scss">
.ticket {
	padding: 10px 0px;
	display: flex;
	align-items: center;
	border-bottom: solid 1px #dbdae3;

	h3 {
		font-size: 1rem;
		font-weight: 500;
	}
	h5 {
		font-size: 0.8rem;
		font-weight: 400;
	}
	.price {
		font-size: 0.9rem;
		font-weight: 500;
	}
	.expire {
		font-size: 0.8rem;
		color: #6f7287;
		line-height: 0.8rem;
	}

	select {
		width: 68px;
		font-size: 1rem;
		margin-left: 4px;
	}
	&.sold {
		opacity: 0.4;
		position: relative;
		overflow: hidden;

		&:before {
			content: "SOLD OUT";
			width: 100px;
			height: 20px;
			text-align: center;
			display: flex;
			justify-content: center;
			background-color: crimson;
			color: #fff;
			position: absolute;
			font-size: 0.8rem;
			top: 17px;
			right: -23px;
			transform: rotate(45deg);
		}
	}
}

.label {
	font-weight: 500;
	color: #1e0a3c;
	font-size: 0.875rem;
	line-height: 1.25rem;
}

.cart {
	.cart-total {
		border-top: 1px solid #eeedf2;
		padding: 16px 0px;
		font-weight: 500;
		font-size: 1.2rem;
		display: flex;
		justify-content: space-between;
	}
}
</style>
